var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlotterCsvReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5C14.2761 9.5 14.5 9.72386 14.5 10V12.667C14.4999 13.1531 14.3066 13.6192 13.9629 13.9629C13.6192 14.3066 13.1531 14.4999 12.667 14.5H3.33301C2.84689 14.4999 2.38085 14.3066 2.03711 13.9629C1.69337 13.6192 1.50009 13.1531 1.5 12.667V10C1.5 9.72386 1.72386 9.5 2 9.5C2.27614 9.5 2.5 9.72386 2.5 10V12.667C2.50009 12.8879 2.58794 13.0997 2.74414 13.2559C2.90034 13.4121 3.11211 13.4999 3.33301 13.5H12.667C12.8879 13.4999 13.0997 13.4121 13.2559 13.2559C13.4121 13.0997 13.4999 12.8879 13.5 12.667V10C13.5 9.72386 13.7239 9.5 14 9.5ZM8 1.5C8.27599 1.50018 8.5 1.72397 8.5 2V8.79395L10.9805 6.31348L11.0586 6.24902C11.2526 6.12108 11.5167 6.1427 11.6875 6.31348C11.8578 6.48426 11.8788 6.74754 11.751 6.94141L11.6875 7.02051L8.35352 10.3535C8.25984 10.4471 8.13241 10.4999 8 10.5C7.86759 10.4999 7.74016 10.4471 7.64648 10.3535L4.31348 7.02051C4.11827 6.8253 4.11838 6.50875 4.31348 6.31348C4.50875 6.11838 4.8253 6.11827 5.02051 6.31348L7.5 8.79297V2C7.5 1.72397 7.72401 1.50018 8 1.5Z",
    fill: "#2BDF68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlotterCsvReport);
export default __webpack_public_path__ + "static/media/blotter_csv_report.047fbcbdd4047ee42c49725409d95c98.svg";
export { ForwardRef as ReactComponent };